<template>
  <modal
    name="drive-upload"
    height="auto"
    width="500px"
    :scrollable="true"
    :adaptive="true"
    class="modal-dialog"
    @closed="$emit('close')"
  >
    <div class="modal-content o-common-modal-content">
      <div class="modal-header text-center">
        <button type="button" class="close" @click="closeModal">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <h4 class="modal-title">Upload Files</h4>
      </div>
      <div class="modal-body">
        <div
          class="drive-upload-drop"
          :class="{ 'drive-upload-drop--active': isDragging }"
          @dragover.prevent="isDragging = true"
          @dragleave.prevent="isDragging = false"
          @drop.prevent="onDrop"
          @click="$refs.fileInput.click()"
        >
          <i class="fa fa-cloud-upload" aria-hidden="true" style="font-size: 48px; color: #ccc;"></i>
          <p style="margin-top: 10px; color: #999;">
            Drag files here or click to browse
          </p>
          <input
            ref="fileInput"
            type="file"
            multiple
            style="display: none;"
            @change="onFileSelect"
          />
        </div>

        <div v-if="selectedFiles.length > 0" class="drive-upload-list">
          <div
            v-for="(f, idx) in selectedFiles"
            :key="idx"
            class="drive-upload-item"
          >
            <span class="drive-upload-item-name">{{ f.name }}</span>
            <span class="drive-upload-item-size">{{ formatSize(f.size) }}</span>
            <a
              v-if="!uploading"
              href="javascript: void(0)"
              @click="removeFile(idx)"
              style="color: #c0392b; margin-left: 8px;"
            >
              <i class="fa fa-times" aria-hidden="true"></i>
            </a>
          </div>
        </div>

        <div v-if="uploading" style="margin-top: 15px;">
          <el-progress :percentage="uploadProgress" :status="uploadProgress === 100 ? 'success' : ''"></el-progress>
          <p style="text-align: center; margin-top: 5px; color: #999; font-size: 12px;">
            Uploading {{ uploadCurrent }} of {{ selectedFiles.length }}...
          </p>
        </div>
      </div>
      <div class="modal-footer text-center">
        <a
          v-if="!uploading"
          href="javascript: void(0)"
          class="c-solid-btn c-solid-btn--green"
          :class="{ 'isDisabled': selectedFiles.length === 0 }"
          @click="startUpload"
        >
          <i class="fa fa-upload" aria-hidden="true"></i> Upload {{ selectedFiles.length > 0 ? '(' + selectedFiles.length + ')' : '' }}
        </a>
        <a
          href="javascript: void(0)"
          class="c-solid-btn"
          style="margin-left: 10px;"
          @click="closeModal"
        >
          {{ uploading ? 'Close' : 'Cancel' }}
        </a>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "DriveUploadDialog",
  props: {
    folderId: { type: String, default: null },
  },
  data() {
    return {
      selectedFiles: [],
      isDragging: false,
      uploading: false,
      uploadProgress: 0,
      uploadCurrent: 0,
    };
  },
  mounted() {
    this.$modal.show("drive-upload");
  },
  methods: {
    onFileSelect: function (e) {
      var files = Array.from(e.target.files || []);
      for (var i = 0; i < files.length; i++) {
        this.selectedFiles.push(files[i]);
      }
    },
    onDrop: function (e) {
      this.isDragging = false;
      var files = Array.from(e.dataTransfer.files || []);
      for (var i = 0; i < files.length; i++) {
        this.selectedFiles.push(files[i]);
      }
    },
    removeFile: function (idx) {
      this.selectedFiles.splice(idx, 1);
    },
    startUpload: function () {
      if (this.selectedFiles.length === 0) return;
      this.uploading = true;
      this.uploadCurrent = 0;
      this.uploadNext();
    },
    uploadNext: function () {
      if (this.uploadCurrent >= this.selectedFiles.length) {
        this.uploadProgress = 100;
        this.$emit("uploaded");
        return;
      }

      var self = this;
      var file = this.selectedFiles[this.uploadCurrent];
      this.uploadCurrent++;
      this.uploadProgress = Math.round(((this.uploadCurrent - 1) / this.selectedFiles.length) * 100);

      var formData = new FormData();
      formData.append("file", file);
      if (this.folderId) {
        formData.append("folder_id", this.folderId);
      }

      this.$emit("upload-file", {
        formData: formData,
        onSuccess: function () {
          self.uploadNext();
        },
        onError: function () {
          self.uploadNext();
        },
      });
    },
    closeModal: function () {
      this.$modal.hide("drive-upload");
      this.$emit("close");
    },
    formatSize: function (bytes) {
      if (!bytes || bytes === 0) return "--";
      var units = ["B", "KB", "MB", "GB"];
      var i = 0;
      var size = bytes;
      while (size >= 1024 && i < units.length - 1) {
        size /= 1024;
        i++;
      }
      return size.toFixed(i > 0 ? 1 : 0) + " " + units[i];
    },
  },
};
</script>

<style scoped>
.drive-upload-drop {
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}
.drive-upload-drop:hover,
.drive-upload-drop--active {
  border-color: #337ab7;
  background: #f5f9fd;
}
.drive-upload-list {
  margin-top: 15px;
  max-height: 200px;
  overflow-y: auto;
}
.drive-upload-item {
  display: flex;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
}
.drive-upload-item-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}
.drive-upload-item-size {
  color: #999;
  font-size: 12px;
  margin-left: 10px;
}
.isDisabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
